import * as actions from "./rentRegistrationDocuments.actions";
import * as api from "./rentRegistrationDocuments.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY, } from "./rentRegistrationDocuments.constants";
import * as hooks from "./rentRegistrationDocuments.hooks";
import * as promises from "./rentRegistrationDocuments.promises";
import reducer from "./rentRegistrationDocuments.reducer";
import { saga } from "./rentRegistrationDocuments.saga";
import * as selectors from "./rentRegistrationDocuments.selectors";
import * as utils from "./rentRegistrationDocuments.utils";
export * from "./rentRegistrationDocuments.types";
export var REDUCER_KEY_RENT_REGISTRATION_DOCUMENTS = REDUCER_KEY;
export var rentRegistrationDocumentsModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
